<template>
  <div>
    <Head title="Editar producto" />
    <div class="flex justify-start mb-8 max-w-3xl">
      <h1 class="text-3xl font-bold">
        <Link class="text-indigo-400 hover:text-indigo-600" href="/products">Producto</Link>
        <span class="text-indigo-400 font-medium">/ Editar</span>
      </h1>
      <img v-if="product.image" class="block ml-4 w-8 h-8 rounded-full" :src="'/storage/' + product.image" />
    </div>
    <!-- <p>{{ form.additionalPrices }}</p> -->
    <trashed-message v-if="product.deleted_at" class="mb-6" @restore="restore"> This product has been deleted.
    </trashed-message>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="update">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <p class="mb-2">Cambiar magen del producto:</p>
          <div class="w-full pb-8 pr-6">
            <input-file v-model="form.product_image_path" :error="form.errors.product_image_path" class="lg:w-full" type="file" accept="image/*" label="Imagen" />
          </div>
          <p>Imagen del producto:</p>
          <div class="p-6 w-full flex justify-center content-center rounded mb-2 mt-2 bg-slate-100">
            <img v-if="product.image" class="w-3/6" :src="'/storage/' + product.image" />
          </div>
          <text-input v-model="form.code" :error="form.errors.code" class="pb-8 pr-6 w-full lg:w-1/3" label="Código" />
          <select-input v-model="form.id_product_family" :error="form.errors.id_product_family" class="pb-8 pr-6 w-full lg:w-1/3" label="Familia">
            <option v-for="family in families" :key="family.id" :value="family.id">{{ family.description }}</option>
          </select-input>
          <select-input v-model="form.id_product_category" :error="form.errors.id_product_category" class="pb-8 pr-6 w-full lg:w-1/3" label="Categoria">
            <option v-for="category in categories" :key="category.id" :value="category.id">{{ category.description }}
            </option>
          </select-input>
          <text-input v-model="form.description" :error="form.errors.description" class="pb-8 pr-6 w-full lg:w-full" label="Descripción" />

          <select-input v-model="form.id_product_unit" :error="form.errors.id_product_unit" class="pb-8 pr-6 w-full lg:w-1/3" label="Unidad de medida">
            <option v-for="unit in units" :key="unit.id" :value="unit.id">{{ unit.code }}</option>
          </select-input>
          <text-input v-model="form.existence" :error="form.errors.existence" class="pb-8 pr-6 w-full lg:w-1/3" type="number" label="Existencia" />
          <text-input v-model="form.barcode" :error="form.errors.barcode" class="pb-8 pr-6 w-full lg:w-1/3" label="Código de barras" />
          <textarea-input v-model="form.details" :error="form.errors.details" class="pb-8 pr-6 w-full" label="Detalles" />
          <!-- <div class="w-full pb-8 pr-6">
            <input-file v-model="form.photo" :error="form.errors.photo" class="lg:w-full" type="file" accept="image/*" label="Imagen" />
          </div>           -->

          <h1 class="text-xl mb-2 w-full">Precios</h1>


          <div class="border-solid border-4 border-gray-300 lg:w-full	mb-4 pt-2 mr-6">
            <div class="flex lg:w-full">
              <div class="pb-2 pr-6 w-full lg:w-1/5">&nbsp;</div>
              <div class="pb-2 pr-6 w-full lg:w-1/5">Por Caja</div>
              <div class="pb-2 pr-6 w-full lg:w-1/5">Unitario</div>
              <div class="pb-2 pr-6 w-full lg:w-1/5">Sugerido</div>
              <div class="pb-2 pr-6 w-full lg:w-1/5">Impuesto</div>
            </div>

            <div v-for="(priceType, index) in form.additionalPrices" :key="index" class="flex lg:w-full">
              <div class="lg:w-1/5 flex justify-end pr-2">
                <button 
                  v-if="index > 0"
                  class=" select-none rounded-lg h-10 bg-red-500 px-6 text-center align-middle font-sans text-xs font-bold uppercase text-white"
                  type="button"
                  @click="removePrice(index)"
                >
                  Quitar
                </button>
              </div>
              <text-input v-model="priceType.price" placeholder="Precio por caja" name="pricesTypes[][price]" class="pb-8 pr-6 w-full lg:w-1/5" type="text" />
              <text-input v-model="priceType.unit_price" placeholder="Precio unitario" name="pricesTypes[][unit_price]" class="pb-8 pr-6 w-full lg:w-1/5" type="text" />
              <text-input v-model="priceType.suggested_price" placeholder="Precio sugerido" name="pricesTypes[][suggested_price]" class="pb-8 pr-6 w-full lg:w-1/5" type="text" />
              <select-input v-model="priceType.taxone" name="pricesTypes[][taxone]" class="pb-8 pr-6 w-full lg:w-1/5">
                <option v-for="tax in taxes" :key="tax.id" :value="tax.id">{{ tax.description }}</option>
              </select-input>
              <div class="flex items-center space-x-2">
                <input 
                  id="checkbox" 
                  v-model="priceType.price_type" 
                  name="pricesTypes[][price_type]" 
                  type="checkbox" 
                  class="form-checkbox h-5 w-5 text-blue-600" 
                  checked="true" 
                />
                <label for="checkbox" class="text-gray-700">Venta por pieza</label>
              </div>
            </div>

            <div class="flex w-full justify-center">
              <button type="button" class="text-white bg-blue-400 hover:bg-blue-800 focus:outline-none focus:ring-blue-300 font-medium rounded-full text-xl px-5 py-2.5 text-center me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800" @click="addNewPrice">+</button>
            </div>
          </div>
        </div>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-sky" type="submit">Actualizar Producto</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import InputFile from '@/Shared/InputFile'
import TextInput from '@/Shared/TextInput'
import TextareaInput from '@/Shared/TextareaInput'
import FileInput from '@/Shared/FileInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'

export default {
  components: {
    InputFile,
    FileInput,
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
    TextareaInput,
    TrashedMessage,
  },
  layout: Layout,
  props: {
    product: Object,
    families: Object,
    categories: Object,
    units: Object,
    price_types: Array,
    taxes: Object,
  },
  remember: 'form',
  data() {
    return {
      pricesTypes: [],
      form: this.$inertia.form({
        product_image_path: null,
        code: this.product.code,
        id_product_family: this.product.family,
        id_product_category: this.product.category,
        description: this.product.description,
        id_product_unit: this.product.unit,
        existence: this.product.existence,
        barcode: this.product.barcode,
        details: this.product.details,        
        additionalPrices: this.product.prices,
        deletedPrices: []
      }),
    }
  },
  beforeMount() {
    this.form.additionalPrices.forEach(item => {
      if (item.price_type === 2) {
        item.price_type = true
      }else{
        item.price_type = false
      }
    })
    console.log(this.form.additionalPrices)

  },
  mounted() {
    
  },
  methods: {
    update() {
      this.form.additionalPrices.forEach(item => {
        if (item.price_type) {
          item.price_type = 2
        }else{
          item.price_type = 1
        }
      })
      console.log(this.form);1
      this.form.post(`/products/${this.product.id}`, {
        onSuccess: () => {
          this.form.defaults()
        },
      })

    },
    destroy() {
      if (confirm('Are you sure you want to delete this product?')) {
        this.$inertia.delete(`/products/${this.product.id}`)
      }
    },
    restore() {
      if (confirm('Are you sure you want to restore this product?')) {
        this.$inertia.put(`/products/${this.product.id}/restore`)
      }
    },
    getNamePriceType(number) {
      const unit = this.price_types.find(cat => cat.id === number);
      let name_price_default = "Precio " + number
      return unit ? unit.name : name_price_default;
    },
    addNewPrice: function () {
      this.form.additionalPrices.push({
        price: 0,
        unit_price: 0,
        suggested_price: 0,
        taxone: 3,
        price_type: false,
      })      
      //this.apartments.push(Vue.util.extend({}, this.apartment))
    },
    removePrice: function (index) {
      console.log(index, this.form.additionalPrices[index])
      const hasId = this.form.additionalPrices[index].hasOwnProperty('id');
      if (hasId) {
        let id = this.form.additionalPrices[index].id
        this.form.deletedPrices.push(id);
        console.log("Si tenia")
      }
      this.form.additionalPrices.splice(index, 1)
    }

  },
}
</script>